import {
  SET_INITIAL_MEMBER_STATE,
  RESET_BOOK_RESPONSE,
  SET_VISIT_TYPE,
  SET_POSTAL_BTN_ENABLE,
  SET_INCLUDED_MEMBER,
  SET_PINCODE,
  SET_HOME_PINCODE_TYPE,
  SET_TPA_DETAILS,
  SET_DC_LIST,
  SET_SHOW_VISIT_TYPE,
  SET_SELECTED_CENTER_TYPE,
  SET_APPOINTMENT_DATE_TYPE,
  SET_MOBILE_TYPE,
  SET_EMAIL_TYPE,
  SET_ADDRESS_TYPE,
  SET_APPOINTMENT_TIME_TYPE,
  SET_IS_MODAL_OPEN_TYPE,
  SET_ERROR_TYPE,
  RESET_FORM_TYPE,
  SET_CITY_TYPE
} from "./types";

export function setInitialMemberDetails(data) {
  return {
    type: SET_INITIAL_MEMBER_STATE,
    payload: data,
  };
}
export function resetBookMemberDetails() {
  return { type: RESET_BOOK_RESPONSE };
}

//SETTERS//
export function setVisitType(data) {
  return {
    type: SET_VISIT_TYPE,
    payload: data,
  };
}
export function setPostalBtnEnable(data) {
  return {
    type: SET_POSTAL_BTN_ENABLE,
    payload: data,
  };
}
export function setIncludedMember(data) {
  return {
    type: SET_INCLUDED_MEMBER,
    payload: data,
  };
}
export function setPinCode(data) {
  return {
    type: SET_PINCODE,
    payload: data,
  };
}
export function setTpaDetails(data) {
  return {
    type: SET_TPA_DETAILS,
    payload: data,
  };
}
export function setDcList(data) {
  return {
    type: SET_DC_LIST,
    payload: data,
  };
}
export function setShowVisitType(data) {
  return {
    type: SET_SHOW_VISIT_TYPE,
    payload: data,
  };
}

export function setCenterSelected(data) {
  return {
    type: SET_SELECTED_CENTER_TYPE,
    payload: data,
  };
}

export function setAppointmentDate(data) {
  return {
    type: SET_APPOINTMENT_DATE_TYPE,
    payload: data,
  };
}
export function setMobile(data) {
  return {
    type: SET_MOBILE_TYPE,
    payload: data,
  };
}
export function setCity(data){
  return {
    type: SET_CITY_TYPE,
    payload: data,
  }
}
export function setHomePincode(data){
  return {
    type: SET_HOME_PINCODE_TYPE,
    payload: data,
  }
}
export function setEmail(data) {
  return {
    type: SET_EMAIL_TYPE,
    payload: data,
  };
}
export function setAddress(data) {
  return {
    type: SET_ADDRESS_TYPE,
    payload: data,
  };
}
export function setAppointmentTime(data) {
  return {
    type: SET_APPOINTMENT_TIME_TYPE,
    payload: data,
  };
}
export function setIsModalOpen(data) {
  return {
    type: SET_IS_MODAL_OPEN_TYPE,
    payload: data,
  };
}

export function setErrors(data) {
  return {
    type: SET_ERROR_TYPE,
    payload: data,
  };
}
export function resetForm(data) {
  return {type: RESET_FORM_TYPE, payload: data };
}
